export const DEFAULT_WAITLIST_CLOSED_TEXT =
  "You can't add yourself to the online waitlist right now, but we're open!";

export const WAITLIST_ESTIMATE_INFO_SUBHEADER =
  'Estimates are calculated based on historical table turnover data and your current position in the waitlist. Since seating depends on table availability by size, your actual seating time may vary.';
